import { render, staticRenderFns } from "./core_button.vue?vue&type=template&id=4cacd30e&scoped=true"
import script from "./core_button.vue?vue&type=script&lang=js"
export * from "./core_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cacd30e",
  null
  
)

export default component.exports